import { Modal, Upload } from '@arco-design/web-react';
import { UploadItem, UploadProps } from '@arco-design/web-react/lib/Upload';
import React from 'react';
import { useUploadUrl } from './api';
import { ContentLoading } from '@/components';
import axios from 'axios';

export function CustomUpload({
  value,
  onChange,
  limit = 1,
  name = '',
}: UploadProps & {
  value?: UploadItem[] | undefined;
  name?: string;
}) {
  const { data, isLoading, isError, refetch } = useUploadUrl(name);
  if (isLoading) {
    return <ContentLoading />;
  }
  if (isError) {
    return null;
  }
  return (
    <>
      <Upload
        name="file"
        multiple
        listType="picture-card"
        fileList={value}
        limit={limit}
        onChange={(files, file) => {
          files = files.map((file) => {
            if (file.status === 'done' && !file.url) {
              file.url = data.file_url;
            }
            return file;
          });
          onChange!(files, file);
        }}
        customRequest={async (option) => {
          const { file, onSuccess, onProgress, onError } = option;
          const controller = new AbortController();
          try {
            const res = await axios.put(data.upload_url, file, {
              headers: {
                'Content-Type': 'image/jpeg',
              },
              onUploadProgress: (event: any) => {
                let percent = 0;
                if (event.total > 0) {
                  percent = (event.loaded / event.total) * 100;
                }
                onProgress(percent, event);
              },
              signal: controller.signal,
            });
            onSuccess(res);
            await refetch();
          } catch (err: any) {
            onError(err);
          }
          return {
            abort() {
              controller.abort();
            },
          };
        }}
        onPreview={(file) => {
          Modal.info({
            title: '预览',
            content: (
              <div style={{ textAlign: 'center' }}>
                <img style={{ maxWidth: '100%' }} src={file.url} alt="" />
              </div>
            ),
          });
        }}
      />
    </>
  );
}
